











import {fieldProps} from '../BZCore/ActiveField'
import Vue, {VueConstructor} from 'vue'
import Errors from '../errors.vue'
import UiInlineIcon from '../../Icon/InlineIcon.vue'
import RichTextInput from '../../Inputs/RichTextInput.vue'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    input: {reset: () => void}
  }
}>).extend({
  name: 'RichTextField',
  props: fieldProps,
  components: {Errors, UiInlineIcon, RichTextInput},
  created () {
    if (!this.value && this.defaultValue) {
      this.$emit('input', this.defaultValue)
    }
  },
  watch: {
    defaultValue (newValue, oldValue) {
      if (!this.value || this.value === oldValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    onInput (event: string) {
      this.$emit('input', event)
    },
    reset () {
      this.$refs.input.reset()
    }
  },
  computed: {
    currentValue: {
      get (): string {
        if (this.value && this.value.toString) {
          return this.value.toString()
        }
        return this.value as string || ''
      },
      set () {

      }
    }
  }
})
